import React from 'react';

// import { useTheme } from 'utils/Theme';
import { SuccessGeneratedProps } from './Success.props';
import { StyledResult } from './Success.style';

const SuccessView = (props: SuccessGeneratedProps): JSX.Element => {
  // const theme = useTheme();
  return (
    <StyledResult status="success" title="Successfully Submitted Assessment!" />
  );
};

export default SuccessView;
